export const OTHER_DOCUMENT_TYPE_ID = 24;